export enum RoutePath {
    Nft = 'page-nft',
    DEMI = 'page-demi',
}
const root = RoutePath.Nft;
export function getUrl(path: string) {
    if (path.startsWith('/')) {
        path = path.slice(1);
    }
    return `${process.env.VITE_APP_BASE_URL}${path}`;
}

export function getUrlFromRoute(route: RoutePath) {
    const path = route.replace(root, '');
    return getUrl(`${path}`);
}

export function goPage(page: RoutePath, sub?: string) {
    if (sub) {
        window.location.href = `${getUrlFromRoute(page)}#${sub}`;
    } else {
        window.location.href = getUrlFromRoute(page);
    }
}
